import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { LABEL_PROPAGATION_PARAMETERS } from "../../helpers/constants/miscellaneous";

/** Removes the label propagation params from the given search params (in place) and returns them */
export const deleteLabelPropagationParams = (searchParams: URLSearchParams) => {
  LABEL_PROPAGATION_PARAMETERS.forEach((param) => searchParams.delete(param));
  return searchParams;
};

export const useClearLabelPropagationSearchParams = () => {
  const navigate = useNavigate();
  return useCallback(() => {
    const searchParams = deleteLabelPropagationParams(
      new URLSearchParams(window.location.search),
    );
    navigate({ search: searchParams.toString() });
  }, [navigate]);
};
